import gql from 'graphql-tag';

export const QUERY_PRODUCTS_SEARCH = gql`query QueryProductsSearch($search: String, $tagName: [String], $categoryName: [String]) {
  products(first: 8, where: {search: $search, tagIn: $tagName, categoryIn: $categoryName}) {
    nodes {
      databaseId
      slug
      name
      reviewCount
      type
      link
      image {
        sourceUrl(size: SHOP_THUMBNAIL)
      }
      link
      ... on SimpleProduct {
        price
      }
      ... on VariableProduct {
        id
        name
        regularPrice
      }
      acfProducts {
        productType
      }
    }
  }
}
`;
export default QUERY_PRODUCTS_SEARCH;